export default "__VITE_ASSET__99f38b44__"